import React, { Fragment } from "react";
import { snakeCase } from "lodash";
import { useHistory } from "react-router";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { useLocalStore, useStoreActions } from "easy-peasy";
import I18n from "utils/i18n.js";
import { pageRoutes } from "services/api";
import { PrimaryBtn } from "components/admin_v2/ui/Buttons";
import AddressesForm from "components/admin_v2/common/AddressesForm";
import PhoneNumbersForm from "components/admin_v2/common/PhoneNumbersForm";
import VendorDetailsForm from "./VendorDetailsForm";
import { vendorFormStore } from "components/admin_v2/vendor_config/stores/vendorFormStore";
import useCommonPageStyles from "components/admin_v2/common/useCommonPageStyles";

const VendorForm = ({ vendor }) => {
  const cls = useCommonPageStyles();
  const history = useHistory();
  const formStore = useLocalStore(() => vendorFormStore(vendor));
  const [state, actions] = formStore;
  const { setFlashMessage } = useStoreActions((s) => s.app);

  const onSubmit = () => {
    actions.save().then((resp) => {
      setFlashMessage({ message: resp.message });
      history.push(pageRoutes.vendor(resp.vendor.id));
    });
  };

  const forms = {
    details: <VendorDetailsForm formStore={formStore} />,
    addresses: <AddressesForm store={formStore} withoutSchool={true} addressRequired={false} />,
    phoneNumbers: <PhoneNumbersForm store={formStore} phoneRequired={false} />
  };

  return (
    <Fragment>
      {Object.entries(forms).map(([formTitle, form]) => (
        <Box key={formTitle} my={2.5} className={`vendor-form-${snakeCase(formTitle)}`}>
          <Paper className={cls.paper}>
            <div className={cls.subTitle}>
              {I18n.t(`vendor_config.vendor.title.${snakeCase(formTitle)}`)}
            </div>
            {form}
          </Paper>
        </Box>
      ))}
      <Box my={5}>
        <PrimaryBtn size="large" onClick={onSubmit} disabled={state.loading || !state.isValid}>
          {I18n.t("ui.btn.save")}
        </PrimaryBtn>
      </Box>
    </Fragment>
  );
};

export default VendorForm;
